// src/navbar/Navbar.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import { MenuItems } from './MenuItems';
import LoginButton from '../components/LoginButton';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import { useAuth } from '../context/AuthContext';

function Navbar() {
    const [click, setClick] = useState(false);
    const [manufacturersExpanded, setManufacturersExpanded] = useState(false);
    const [dropdown, setDropdown] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const { isAuthenticated } = useAuth();

    // Check if the screen is mobile size
    const checkMobile = () => {
        setIsMobile(window.innerWidth <= 960);
    };

    // Add event listener for window resize
    useEffect(() => {
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => {
            window.removeEventListener('resize', checkMobile);
        };
    }, []);

    const handleClick = () => setClick(!click);
    
    const closeMobileMenu = () => {
        setClick(false);
        setManufacturersExpanded(false);
        setDropdown(false);
    };

    const toggleManufacturers = (e) => {
        if (isMobile) {
            e.preventDefault();
            setManufacturersExpanded(!manufacturersExpanded);
        }
    };

    const onMouseEnter = () => {
        if (!isMobile) {
            setDropdown(true);
        }
    };

    const onMouseLeave = () => {
        if (!isMobile) {
            setDropdown(false);
        }
    };

    return (
        <>
            <nav className='navbar'>
                <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
                    StockMaid
                </Link>
                <div className='menu-icon' onClick={handleClick}>
                    <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
                </div>
                <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                    <li className='nav-item'>
                        <Link to='/' className='nav-links' onClick={closeMobileMenu}>
                            Home
                        </Link>
                    </li>
                    
                    {/* Combined Mobile/Desktop Manufacturers Menu */}
                    <li 
                        className='nav-item'
                        onMouseEnter={onMouseEnter}
                        onMouseLeave={onMouseLeave}
                    >
                        <div className='dropdown-container'>
                            <Link
                                to={isMobile ? '#' : '/manufacturers/ASUS'}
                                className={`nav-links ${manufacturersExpanded ? 'active' : ''}`}
                                onClick={toggleManufacturers}
                            >
                                Manufacturers
                                <i className={
                                    isMobile ? 
                                        (manufacturersExpanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down') :
                                        'fas fa-caret-down'
                                } />
                            </Link>
                            
                            {/* Mobile Dropdown */}
                            {isMobile && manufacturersExpanded && (
                                <ul className='mobile-dropdown'>
                                    {MenuItems.map((item, index) => (
                                        <li key={index}>
                                            <Link
                                                to={item.path}
                                                className='mobile-dropdown-link'
                                                onClick={closeMobileMenu}  // This will close the entire mobile menu
                                            >
                                                {item.title}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            )}
                            
                            {/* Desktop Dropdown */}
                            {!isMobile && dropdown && (
                                <ul className='desktop-dropdown'>
                                    {MenuItems.map((item, index) => (
                                        <li key={index}>
                                            <Link
                                                to={item.path}
                                                className='dropdown-link'
                                                onClick={closeMobileMenu}  // This will close desktop dropdown too
                                            >
                                                {item.title}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </li>
                    
                    <li className='nav-item'>
                        <Link
                            to='/dates/2025-01-02/2026-01-02'
                            className='nav-links'
                            onClick={closeMobileMenu}
                        >
                            New Releases
                        </Link>
                    </li>

                    {/* Autobuys - Only shown when authenticated */}
                    {isAuthenticated && (
                        <li className='nav-item'>
                            <Link
                                to='/my-tracked-stocks'
                                className='nav-links'
                                onClick={closeMobileMenu}
                            >
                                <BookmarkIcon sx={{ mr: 0.5, fontSize: '0.9rem' }} />
                                Autobuys
                            </Link>
                        </li>
                    )}
                    
                    {/* Add login for mobile view - Pass closeMobileMenu function */}
                    <li className='login-mobile'>
                        <div className='login-wrapper'>
                            <LoginButton onNavAction={closeMobileMenu} />
                        </div>
                    </li>
                </ul>
                {/* Add login for desktop view - No need to pass closeMobileMenu since it's not in the mobile menu */}
                <div className='nav-auth'>
                    <LoginButton />
                </div>
            </nav>
        </>
    );
}

export default Navbar;